import { computed, type Ref } from "vue";
import { generateUUID } from "@/src/shared/utils/uuid";

export const useOptionListIdentity = (listId: Ref<string | undefined>) => {
  const resolvedListId = computed(() => listId.value ?? `ds-option-list-${generateUUID()}`);

  return { resolvedListId };
};
